module.exports = __webpack_public_path__ + "img/Contenant_a_dragees.138cca1.jpg";